// 登録用文字列長
export const 汎用区分コード = 50
export const 会社コード = 1
export const 営業所管コード = 2
export const 営業所コード = 3
export const 部所コード = 4
export const 部所権限コード = 4
export const 社員コード = 4
export const 荷主コード = 5
export const 積卸先コード = 10
export const 支払先コード = 10
export const 車番 = 4
export const 品コード = 5
export const 受注配車パターンコード = 20
export const 表紙分割コード = 3
export const 請求内訳コード = 3
export const 一般名称 = 100
export const 一般カナ名称 = 200
export const 一般略称 = 100
export const 区分名称 = 100
export const 一般テキスト = 1000
export const 郵便番号 = 8
export const 団体コード = 6
export const 都道府県コード = 2
export const 住所１ = 15
export const 住所２ = 15
export const 住所３ = 100
export const 電話番号 = 15
export const メールアドレス = 254
export const パスワード = 100
export const URL = 2000
export const CSVフィールド = 30
export const 大陽社員コード = 6
export const インボイス登録番号 = 20

// 入力パターン
export const 数字のみ = "^\\d+$"
export const 英数字のみ = "^[a-zA-Z0-9]+$"
export const アルファベットのみ = "^[a-zA-Z]+$"

export const e入力パターン = {
  数字のみ: 1,
  英数字のみ: 2,
  アルファベットのみ: 3,
} as const

export type T入力パターン名称 = keyof typeof e入力パターン
export type T入力パターン = typeof e入力パターン[T入力パターン名称]

const VALIDATE_CONSTANT = {
  PATTERN: { 数字のみ, 英数字のみ, アルファベットのみ },
  LENGTH: {
    汎用区分コード,
    受注配車パターンコード,
    会社コード,
    営業所管コード,
    営業所コード,
    部所コード,
    部所権限コード,
    社員コード,
    荷主コード,
    積卸先コード,
    支払先コード,
    車番,
    品コード,
    表紙分割コード,
    請求内訳コード,
    一般名称,
    一般カナ名称,
    一般略称,
    区分名称,
    一般テキスト,
    郵便番号,
    団体コード,
    都道府県コード,
    住所１,
    住所２,
    住所３,
    電話番号,
    メールアドレス,
    パスワード,
    URL,
    CSVフィールド,
    大陽社員コード,
    インボイス登録番号,
  },
} as const
export default VALIDATE_CONSTANT
